export function removeElementStyles(el) {
  el.style.cssText = '';
}